import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 1300,
  parentId: 1000,
  name: "About",
  label: "About",
  path: "about",
  icon: "info-sign",
  element: Element,
  footer: true,
  user: false,
  admin: false,
  hidden: false,
};

export default route;
